import React from 'react';
import { COPY } from '../contracts/copyMap';
import PublicPageLayout from '../components/public/PublicPageLayout';
import StructuredData from '../components/public/StructuredData';
import { faqPageLd } from '../contracts/structuredData';

// Public FAQ — every question expanded in the DOM (no accordion) so the
// content is fully crawlable. Items live in COPY.FAQ_ITEMS.
//
// The FAQPage markup is generated from the SAME COPY.FAQ_ITEMS rendered below,
// so the structured data can never drift from the visible answers — Google
// treats that divergence as cloaking. This page was already built for crawlers;
// the markup is the completion of that work.
const Faq = () => (
  <PublicPageLayout
    title={COPY.PAGE_TITLE_FAQ}
    eyebrow={COPY.FAQ_EYEBROW}
    headline={COPY.FAQ_HEADLINE}
  >
    <StructuredData id="ld-faq" data={faqPageLd()} />
    <div className="space-y-10">
      {COPY.FAQ_ITEMS.map((item) => (
        <section key={item.question}>
          <h3 className="m-0 font-display text-[20px] leading-snug text-bone">
            {item.question}
          </h3>
          <p className="mt-3 m-0 font-display text-[15px] leading-relaxed text-bone-dim">
            {item.answer}
          </p>
        </section>
      ))}
    </div>
  </PublicPageLayout>
);

export default Faq;
